import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  catchError,
  Observable,
  retry,
  Subject
} from 'rxjs';
import { environment } from 'src/environments/environment';
import { SubscriptionModel } from '../interfaces/subscription.interface';
import { handleError } from '../utils/generic-utils';

/** A MagicInfo server was removed from the list: the Integrations 3rd party section loads its servers again. */
export const THIRD_PARTY_RELOAD_CHANNEL = 'MagicInfoTableComponent - IntegrationsThirdPartyComponent';

@Injectable({
  providedIn: 'root',
})
export class MagicInfoService {
  endpoint: string = environment.performTVApi.url;
  headers = new HttpHeaders({
    'Content-Type': 'application/json',
    responseType: 'json',
  });
  retry = 0;

  constructor(private http: HttpClient) {}

  // ! Add correct the type for this
  private subjectMISubs = new Subject<any>();

  sendMISubs(data: SubscriptionModel) {
    this.subjectMISubs.next(data);
  }

  getMISubs() {
    return this.subjectMISubs.asObservable();
  }

  deleteMagicInfo(magicInfoId: string): Observable<any>{
    let api = `${this.endpoint}/device-group/${magicInfoId}/magic-info`;
    return this.http
      .delete(api, { headers: this.headers, responseType: "json" })
      .pipe(retry(this.retry), catchError(handleError));
  }

  createMagicInfo(payload: Object): Observable<any>{
    let api = `${this.endpoint}/device-groups/magic-info`;
    return this.http
      .post(api, payload, { headers: this.headers, responseType: "json" })
      .pipe(retry(this.retry), catchError(handleError));
  }

  editMagicInfo(magicInfoId: string, payload: Object): Observable<any>{
    let api = `${this.endpoint}/device-group/${magicInfoId}/magic-info`;
    // return of({ id: "newId" })
    return this.http
      .put(api, payload, { headers: this.headers, responseType: "json" })
      .pipe(retry(this.retry), catchError(handleError));
  }

  getMagicInfoSyncHistory(): Observable<any>{
    let api = `${this.endpoint}/device-groups/magic-info/sync-history`;
    // return of({ id: "newId" })
    return this.http
      .get(api, { headers: this.headers, responseType: "json" })
      .pipe(retry(this.retry), catchError(handleError));
  }

  // async convertFqdn2Ip(fqdn: string) {
  //   let api = `${this.endpoint}/nslookup`;
  //   return this.http
  //     .post(api, {"fqdn": fqdn}, { headers: this.headers, responseType: "json" })
  //     .pipe(retry(this.retry), catchError(this.handleError));
  // }

  nslookup( fqdn: string): Observable<any>{
    let api = `${this.endpoint}/nslookup`;

    return this.http
      .post(api, {fqdn: fqdn}, { headers: this.headers, responseType: "json" })
      .pipe(retry(this.retry), catchError(handleError));
  }

  ipDetails( ip_address: string): Observable<any>{
    let api = `${this.endpoint}/ip-details`;

    return this.http
      .post(api, {ip_address: ip_address}, { headers: this.headers, responseType: "json" })
      .pipe(retry(this.retry), catchError(handleError));
  }

  submitTestConnection(payload: Object): Observable<any>{
    let api = `${this.endpoint}/magic-info/test-connection`;

    return this.http
      .post(api, payload, { headers: this.headers, responseType: "json" })
      .pipe(retry(this.retry), catchError(handleError));
  }



}
